import apiConfig from '@constants/apiConfig';
import { getCacheIsAdmin } from '@services/userService';
import { accountActions } from '@store/actions';
import { processAction } from '@store/utils';
import { takeLatest } from 'redux-saga/effects';

const loginSaga = (payload) => processAction(apiConfig.account.login, payload);

const getProfileSaga = (payload) => {
    const isAdmin = getCacheIsAdmin();
    const api = isAdmin ? apiConfig.account.getProfile : apiConfig.account.getShopAccountProfile;
    return processAction(api, payload);
};

const sagas = [
    takeLatest(accountActions.login.type, loginSaga),
    takeLatest(accountActions.getProfile.type, getProfileSaga),
];

export default sagas;
